/**
 * Readable message of a failed request. The generated client rejects with the
 * error body (a plain object, not an `Error`), so `String(err)` would give
 * "[object Object]": `Error` → its message; body with a string `message` →
 * that message; anything else → `fallback`.
 */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error) return err.message;
  if (typeof err === 'object' && err !== null && 'message' in err) {
    return typeof err.message === 'string' ? err.message : fallback;
  }
  return fallback;
}
